import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {STALE_TIME} from "../utils/basic";

export const useQueryBase = (queryKey, queryFn, options = {}) => {
    if (!Array.isArray(queryKey)) {
        queryKey = [queryKey];
    }
    return useQuery({
        queryKey,
        queryFn,
        staleTime: STALE_TIME,
        refetchOnWindowFocus: false,
        retry: 1,
        onError: (error) => {
            console.error(`Error fetching data for ${queryKey}:`, error);
        },
        ...options
    });
}

export const useMutationBase = (queryKey, mutationFn) => {
    if (!Array.isArray(queryKey)) {
        queryKey = [queryKey];
    }
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey});
        },
        onError: (error) => {
            console.error("Error updating country data:", error);
        }
    });
}